import ContactAddressModelBase from '../_generated/modelBases/contact-address-model-base';

export default class ContactAddressModel extends ContactAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
